import $axios from '~/plugins/axios';
import { buildModule } from '../utils';
import { Api, CustomFieldRequest } from '~/api';

const api = $axios as Api;

export default buildModule()
	.withActions({
		async post (_, customField: CustomFieldRequest) {
			await api.post('/custom-field', customField);
		},
		async update (_, { id, ...customField }: {
			id: number;
		} & CustomFieldRequest) {
			await api.put(`/custom-field/${ id }`, customField);
		},
		async delete (_, id: number) {
			await api.delete(`/custom-field/${ id }`);
		},
	});
